var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block  pt-5 pb-6 my-0",class:_vm.article.class},[_c('div',{staticClass:"container"},[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.article.image.src,"alt":_vm.article.image.alt}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }